/**
 * Legacy URL: /semaglutide-versus-weight-loss-surgery-outcomes/bypass.
 * Permanent redirect to the gastric bypass page (/services/bypass).
 * Intentionally excluded from the sitemap (redirect target only).
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/semaglutide-versus-weight-loss-surgery-outcomes/bypass")({
  beforeLoad: () => {
    throw redirect({ to: "/services/bypass", statusCode: 301, replace: true });
  },
});
